import angular from 'angular'

import template from './vd-nav-item.html'

/**
 * A navigation item that resides in the any of the navigation bars.
 *
 * @param {Boolean} [active]
 *        Whether or not the current nav item is active (e.g. highlighted in the menu)
 *
 * @param {Boolean} [pending]
 *        Whether or not the current nav item is pending (i.e. clicked on and in the process of navigating)
 *
 * @param {String} [label]
 *        The label to display on the nav item
 *
 * @param {String} [icon]
 *        The name of the icon class to apply (either fa-* or vd-i-*)

 * @param {String} [href]
 *        The href that should be navigated to when clicking on the nav item
 *        (incompatible with `action`)
 *
 * @param {Function} [action]
 *        The action to peform when clicking on the nav item - will be invoked with the `$event`
 *        (incompatible with `href`)
 *
 * @param {Any} [actionParam]
 *        An additional parameter to pass to the `action` function when the nav item is clicked on. This value will be
 *        the second parameter in the invoked function (the first is $event). Can be an array or object if more than one
 *        value needs to be passed.
 */
angular.module('vend.ui').directive('vdNavItem', function (elementService) {
  return {
    restrict: 'E',
    scope: {
      active: '=?',
      pending: '=?',
      label: '=?',
      icon: '=?',
      href: '=?',
      action: '=?',
      actionParam: '=?',
      disabled: '=?',
    },
    template,
    bindToController: true,
    controllerAs: 'vdNavItemCtrl',
    link(scope, $element, attrs) {
      const colour = elementService.getComponentAttrs(attrs, 'colour')
      const target = elementService.getComponentAttrs(attrs, 'target')

      if (colour && Boolean(colour.length)) {
        attrs.$addClass(`vd-nav-item--${colour}`)
      }

      if (target && Boolean(target.length)) {
        // Only add target attribute on child anchor if set, otherwise breaks angular routing
        $element.find('a').attr('target', target)
      }

      attrs.$addClass('vd-nav-item')
    },
    controller($scope, $element) {
      const NO_OP_HREF = '#'

      /**
       * Get the href to set on the nav item's anchor element.
       *
       * @method getHref
       *
       * @return {String} The href that will be navigated to when the nav item is clicked
       */
      this.getHref = function () {
        return this.href || NO_OP_HREF
      }

      /**
       * Handle a click event on the nav item by invoking the `action` function if it is configured.
       *
       * @method onClick
       *
       * @param  {Event} $event
       *         The DOM event for the click
       */
      this.onClick = function ($event) {
        if (this.disabled) {
          $event.preventDefault()
          $event.stopPropagation()
          $event.stopImmediatePropagation()
          return false
        }

        if (this.action && angular.isFunction(this.action)) {
          this.action($event, this.actionParam)
        }
      }

      $scope.$watch('vdNavItemCtrl.active', isActive => {
        $element.toggleClass('vd-nav-item--active', Boolean(isActive))
      })

      $scope.$watch('vdNavItemCtrl.pending', isPending => {
        $element.toggleClass('vd-nav-item--pending', Boolean(isPending))
      })

      $scope.$watch('vdNavItemCtrl.disabled', isDisabled => {
        $element.toggleClass('vd-nav-item--disabled', Boolean(isDisabled))
      })
    },
  }
})
